@if (status === REQUEST_STATUS.APPROVED || status === REQUEST_STATUS.REPROVED) {
  <div class="container-decisions">
    <p *ngIf="approvalsUser">
      <span class="title">{{ 'approvalspage.modalRequestActions.approvalUser' | cxTranslate }}:</span>
      <span>{{ approvalsUser }}</span>
    </p>

    <p *ngIf="approvalsDate">
      <span class="title">{{ 'approvalspage.modalRequestActions.approvalDate' | cxTranslate }}:</span>
      <span>{{ approvalsDate | cxDate: 'MM/dd/yyyy' }}</span>
    </p>
  </div>
}

<div class="actions" [ngClass]="{ 'h-end-i': status !== REQUEST_STATUS.PENDING }">
  <button type="button" class="btn btn-outline-primary" (click)="close()">{{ 'approvalspage.modalRequestActions.cancel' | cxTranslate }}</button>

  @if (status === REQUEST_STATUS.PENDING) {
    <div class="sub-actions">
      <button type="button" class="btn btn-danger" (click)="reply(REPLY_REQUEST.REPROVE)">
        <span class="material-symbols-outlined d-flex m-r-4"> do_not_disturb_on </span>
        {{ 'approvalspage.modalRequestActions.deny' | cxTranslate }}
      </button>

      <button type="button" class="btn btn-primary" (click)="reply(REPLY_REQUEST.APPROVE)">
        <span class="material-symbols-outlined d-flex m-r-4"> check_circle </span>
        {{ 'approvalspage.modalRequestActions.approve' | cxTranslate }}
      </button>
    </div>
  }
</div>